export default "__VITE_ASSET__CDe2XIj5__"